import React, { Component } from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Modal,
  message,
  Checkbox,
  Upload,
  Button,
  Tabs,
  Row,
  Col,
  ColorPicker,
  Tooltip,
  Spin,
  Divider,
} from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { StoreContext } from "../store/RootStore";
import VehicleStore from "../store/VehicleSecuretrackStore";
import CountryStore from "../store/CountryStore";
import CompanyStore from "../store/CompanyStore";
import { observer } from "mobx-react";
import config from "../config";
import withRouter from "../withRouter";
import { addMonths, format } from "date-fns";
const { Option } = Select;

class Superpath extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      newCompany: "",
      selectedCompanyId: null,
      loadingSpin: false,
      countries: [],
      timezones: []
    };
    this.vehicleStore = new VehicleStore(this);
    this.countryStore = new CountryStore(this);
    this.companyStore = new CompanyStore(this);

  }

  
  closeModal = () => {
    this.props.closeModal();
  };

   validateNumber = (value, field1) => {
    // Check if value contains only numbers
    const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9+]*/g, "");
    console.log(value1.length);
    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };
  validatePhoneNumber = (value, field1) => {
    // Check if value contains only numbers
    const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9+]*/g, "");
    console.log(value1.length);
    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };

  async componentDidMount() {
   
    const countries = await this.countryStore.getCountry();
    const timezones =  await this.countryStore.getTimeZone();
    this.setState({countries:countries,timezones:timezones})
  }

  onAccountDetailSubmit = async (fieldsValue) => {

   // console.log(fieldsValue);
    const data = {
      ...fieldsValue,
      project: config.project === "securetrack" ? config.project : "",
      cuserId: this.state.cuserId,
      user: {
        name: fieldsValue.name,
        username: fieldsValue.username,
        password: fieldsValue.password,
        roleId: 331,
        isadmin: 3,
      },
      companystatus: 1,
      addedByUserType : localStorage.originalUserType,
      customerDistributor: 'Distributor', 
     loggeduserId: this.props.getUserData().userId,
     Accountexpirydate : fieldsValue?.Accountexpirydate?.length > 0
               ? format(
                   addMonths(new Date(), Number(fieldsValue?.Accountexpirydate)),
                   "yyyy-MM-dd"
                 )
               : fieldsValue?.Accountexpirydate,
      // customerDistributor:
      //   this.props.getUserData().isadmin !== -1
      //     ? "Customer"
      //     : fieldsValue.customerDistributor,
    };

   const response = await this.companyStore.addData(data);
    await this.props.response2(response);

  }

  
  render() {
  

    return (
      <>
        <div style={{ padding: 0 }}>
          <div>
            <Spin spinning={this.state.loadingSpin} fullscreen>
              <Form
                ref={this.formRef}
                className="formClass"
                layout="vertical"
                onFinish={this.onAccountDetailSubmit}
                initialValues={{
              
                countryCode1: config.countryCode,
               
              }}
                onFinishFailed={this.handleFormError}
                name="nest-message"
              >
                <Row style={{ overflowY: "scroll", height: "480px" }}>
                  <Col span={12} className="formColumnClass">
                    <Form.Item
                      name="companyname"
                      label={this.context.translate("_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_")}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="country"
                      label={this.context.translate("_FLEET_COMPANY_COMPANYDETAIL_COUNTRY_")}
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        placeholder={this.context.translate("_SELECT_COUNTRY_")}
                        filterOption={(inputValue, option) =>
                          option.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        }
                        onSelect={async (value) => {
                          const selectedCountry = this.countryStore?.country.find(
                            (country) => parseInt(country.countryId) === value
                          );
                          await this.formRef.current.setFieldsValue({
                            countryCode1: selectedCountry?.countryCode,
                            countryCode2: selectedCountry?.countryCode,
                          });
                        }}
                      >
                        {this.state.countries.map((country) => (
                          <Option value={parseInt(country.countryId)}>{country.country}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="timezoneId"
                      label={this.context.translate("_FLEET_COMPANY_COMPANYDETAIL_TIME_")}
                      rules={[{ required: true }]}
                      initialValue={this.state.timezoneId}
                    >
                      <Select
                        disabled={this.props.getUserData().isadmin === 1}
                        showSearch
                        placeholder="Select TimeZone"
                        filterOption={(inputValue, option) =>
                          option.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        }
                      >
                        {this.state.timezones.map((country) => (
                          <Option value={parseInt(country.timezoneId)}>{country.abbr}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                                              
                                              name="contact1"
                                              // label="Contact 1"
                                              label={this.context.translate("_CONTACT1_")}
                                              // rules={[{ required: true }]}
                                              rules={[{ required: true }]}
                                            >
                                              <Input disabled={this.state.disabledField} />
                                            </Form.Item>
                                             <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                                            <Form.Item
                                                                      style={{ width: "40%" }}
                                                                      name="countryCode1"
                                                                      // label="Contact 1"
                                                                      label={" "}
                                                                      // rules={[{ required: true }]}
                                                                      rules={[{ required: true }]}
                                                                    >
                                                                      <Select
                                                                        disabled={this.state.disabledField}
                                                                        showSearch
                                                                        filterOption={(inputValue, option) => {
                                                                          if (option.children) {
                                                                            return (
                                                                              option.children
                                                                                .toLowerCase()
                                                                                .indexOf(inputValue.toLowerCase()) >= 0
                                                                            );
                                                                          }
                                                                        }}
                                                                      >
                                                                        {this.countryStore?.country?.map((country) => {
                                                                          return (
                                                                            <Option
                                                                              key={country.countryId}
                                                                              value={parseInt(country.countryId)}
                                                                            >
                                                                              {country.countryCode}
                                                                            </Option>
                                                                          );
                                                                        })}
                                                                        {/* <Select.Option value={91}>+91</Select.Option>
                                                                        <Select.Option value={966}>+966</Select.Option>
                                            
                                                                        <Select.Option value={971}>+971</Select.Option> */}
                                                                      </Select>
                                                                    </Form.Item>
                                            
                                            <Form.Item
                                                                      style={{ width: "50%" }}
                                                                      name="contact1No"
                                                                      // label="Phone Number 1"
                                                                      label={this.context.translate("_PHONE_NUMBER_1_")}
                                                                      rules={[
                                                                        {
                                                                          pattern: /^(\d{7}|\d{8}|\d{9}|\d{10})$/,
                                                                          // pattern: /^\d{8,10}$/,
                                                                          required: true,
                                                                          message: this.context.translate(
                                                                            "_Enter_7_10_Digit_Number_"
                                                                          ),
                                                                        },
                                                                      ]}
                                                                    >
                                                                      <Input
                                                                        disabled={this.state.disabledField}
                                                                        type="tel"
                                                                        // maxLength={13}
                                                                        onChange={(e) => {
                                                                          this.validatePhoneNumber(
                                                                            e.target.value,
                                                                            "contact1No"
                                                                          );
                                                                        }}
                                                                      />
                                                                    </Form.Item>
                                                                    </div>
                                                                      <Form.Item
                                                                                             
                                                                                              name="contact1Email"
                                                                                              // label="Email 1"
                                                                                              label={this.context.translate("_EMAIL_1_")}
                                                                                              // rules={[{ type: "email", required: true }]}
                                                                                              rules={[
                                                                                                {
                                                                                                  type: "email",
                                                                                                  // message: "Please enter a valid email address", // Custom message for incorrect format
                                                                                                  required: true,
                                                                                                },
                                                                                              ]}
                                                                                            >
                                                                                              <Input disabled={this.state.disabledField} />
                                                                                            </Form.Item>

                                            
                  </Col>
                  <Col span={12} className="formColumnClass">
                    <Form.Item
                      name="Accountexpirydate"
                      label={
                        this.props.companyIdForEdit
                          ? this.context.translate("_FLEET_COMPANY_COMPANYDETAIL_EXPIREDATE_")
                          : this.context.translate("_FLEET_COMPANY_COMPANYDETAIL_EXPIREMONTHS_")
                      }
                      rules={[{}]}
                    >
                      <Input
                        onChange={(e) => {
                          this.validateNumber(e.target.value, "Accountexpirydate");
                        }}
                        disabled={this.props.companyIdForEdit ? true : false}
                        placeholder={this.context.translate("_ENTER_MONTHS_")}
                      />
                    </Form.Item>
                     <Form.Item
                              name="name"
                              // label="User Name"
                              label={this.context.translate(
                                "_FLEET_DASHBORD_NEWPOI_NAME_"
                              )}
                              rules={[{ required: true }]}
                            >
                              <Input />
                            </Form.Item>
                     <Form.Item
                                                name="username"
                                                // label="User Name"
                                                label={this.context.translate(
                                                  "_FLEET_COMPANY_USERDETAIL_USERNAME_"
                                                )}
                                                rules={[{ required: true }]}
                                              >
                                                <Input autoComplete="off" />
                                              </Form.Item>
                    
                                              <Form.Item
                                                // label="Password"
                                                label={this.context.translate(
                                                  "_FLEET_COMPANY_USERDETAIL_PASSWORD_"
                                                )}
                                                name="password"
                                                rules={[
                                                  {
                                                    required: true,
                                                  },
                                                ]}
                                              >
                                                <Input.Password
                                                  autoComplete="new-password"
                                                  id="form-password"
                                                />
                                              </Form.Item>
                    
                  </Col>
                </Row>
                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    onClick={(e) => {
                      this.closeModal();
                    }}
                  >
                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                  </Button>
                  <Button type="primary" className="formSaveButton" htmlType="submit">
                    {this.context.translate("_ADD_")}
                  </Button>
                </div>
              </Form>
            </Spin>
          </div>
        </div>
      </>
    );
  }
}

Superpath.contextType = StoreContext;
export default observer(withRouter(Superpath));